var _circle, _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#3EBB82"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0005 29.999C23.2848 29.999 30.0005 23.2833 30.0005 14.999C30.0005 12.4173 29.3482 9.98786 28.1995 7.86658C25.5624 5.56217 22.1112 4.16602 18.334 4.16602C10.0497 4.16602 3.33398 10.8817 3.33398 19.166C3.33398 21.7478 3.98624 24.1772 5.13494 26.2985C7.7721 28.6029 11.2233 29.999 15.0005 29.999Z",
    fill: "#48C98E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_910_20708)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5 14.5H20.5V12C20.5 11.6022 20.342 11.2206 20.0607 10.9393C19.7794 10.658 19.3978 10.5 19 10.5H16.5V9.5C16.5 8.96957 16.2893 8.46086 15.9142 8.08579C15.5391 7.71071 15.0304 7.5 14.5 7.5C13.9696 7.5 13.4609 7.71071 13.0858 8.08579C12.7107 8.46086 12.5 8.96957 12.5 9.5V10.5H10C9.60218 10.5 9.22064 10.658 8.93934 10.9393C8.65804 11.2206 8.5 11.6022 8.5 12V15C8.5 15.1326 8.55268 15.2598 8.64645 15.3536C8.74021 15.4473 8.86739 15.5 9 15.5H10.5C10.7652 15.5 11.0196 15.6054 11.2071 15.7929C11.3946 15.9804 11.5 16.2348 11.5 16.5C11.5 16.7652 11.3946 17.0196 11.2071 17.2071C11.0196 17.3946 10.7652 17.5 10.5 17.5H9C8.86739 17.5 8.74021 17.5527 8.64645 17.6464C8.55268 17.7402 8.5 17.8674 8.5 18V21C8.5 21.3978 8.65804 21.7794 8.93934 22.0607C9.22064 22.342 9.60218 22.5 10 22.5H13C13.1326 22.5 13.2598 22.4473 13.3536 22.3536C13.4473 22.2598 13.5 22.1326 13.5 22V20.5C13.5 20.2348 13.6054 19.9804 13.7929 19.7929C13.9804 19.6054 14.2348 19.5 14.5 19.5C14.7652 19.5 15.0196 19.6054 15.2071 19.7929C15.3946 19.9804 15.5 20.2348 15.5 20.5V22C15.5 22.1326 15.5527 22.2598 15.6464 22.3536C15.7402 22.4473 15.8674 22.5 16 22.5H19C19.3978 22.5 19.7794 22.342 20.0607 22.0607C20.342 21.7794 20.5 21.3978 20.5 21V18.5H21.5C22.0304 18.5 22.5391 18.2893 22.9142 17.9142C23.2893 17.5391 23.5 17.0304 23.5 16.5C23.5 15.9696 23.2893 15.4609 22.9142 15.0858C22.5391 14.7107 22.0304 14.5 21.5 14.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_910_20708"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 7)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuest);
export default __webpack_public_path__ + "static/media/quest.f66b2d4e82cf59ebcebde62eeaf34d47.svg";
export { ForwardRef as ReactComponent };